<template>
  <div>
    <BaseInput
      :value="value"
      :disabled="disabled"
      :error="error"
      :label="label"
      :type="inputType"
      :label-cols="labelCols"
      :on-append-icon-click="togglePasswordVisibility"
      :append-icon="appendedIcon"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput';

export default {
  name: 'PasswordInput',

  components: { BaseInput },

  props: {
    value: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    error: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    labelCols: {
      type: [Number, String],
      default: 6,
    },
  },

  data() {
    return {
      showPassword: false,
    };
  },

  computed: {
    inputType() {
      return this.showPassword ? 'text' : 'password';
    },

    appendedIcon() {
      if (this.disabled) {
        return '';
      }
      return this.showPassword ? 'eye-open' : 'eye-close';
    },
  },

  watch: {
    disabled() {
      this.showPassword = false;
    },
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
